// «El programa de seguridad de tu computadora bloqueó Satori Chat» (core/dlpBlock.ts): a company DLP
// filter refused a request — a message or a file may not have gone out, and only that computer's IT can
// fix it. Stays until the person dismisses it (a toast would be gone before it is read); shown again on
// the next block.
import { useEffect, useState } from 'react';
import { DlpBlock } from '../../../core/dlpBlock';
import { t, tf } from '../../../i18n/i18n';
import { PwaIcon } from './pwaIcons';
import './pwa.css';

export function DlpBanner() {
  const [shown, setShown] = useState(false);
  useEffect(() => DlpBlock.subscribe(() => setShown(true)), []);
  if (!shown) return null;
  return (
    <div className="update-banner" role="alert" data-testid="dlp-banner">
      <span className="update-banner-icon">
        <PwaIcon name="shieldAlert" size={18} strokeWidth={1.9} />
      </span>
      <div className="update-banner-text">
        <strong>{t('web.dlp.title')}</strong>
        <span>{tf('web.dlp.body', location.host)}</span>
      </div>
      <div className="update-banner-actions">
        <button type="button" className="update-banner-reload" onClick={() => setShown(false)}>
          {t('web.dlp.ok')}
        </button>
      </div>
    </div>
  );
}
